import { useEffect, useState } from 'react';

/**
 * Subscribes to a CSS media query and re-renders when it flips. Used to switch the
 * game screen to its single-panel (tabbed) layout on narrow/mobile viewports without
 * duplicating the markup.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    try { return window.matchMedia(query).matches; } catch { return false; }
  });

  useEffect(() => {
    let mql: MediaQueryList;
    try { mql = window.matchMedia(query); } catch { return; }
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    // addEventListener isn't available on MediaQueryList in older Safari.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}
